import type { IDeliveryProductConstructorParams } from "@services/sdk/interfaces";
import type { ID } from "@services/sdk/types";
import { map } from "ramda";

import Product from "./product";

class DeliveryProduct extends Product {
	public static EmptyConstructorParams: IDeliveryProductConstructorParams = {
		discountPrice: 0,
		description: "",
		price: 0,
		id: null,
		name: "",
		type: "",
	};

	public static ConstructEmpty(): DeliveryProduct {
		return DeliveryProduct.Construct(DeliveryProduct.EmptyConstructorParams);
	}

	public static ConstructList(
		arrParams: Array<IDeliveryProductConstructorParams>,
	): Array<DeliveryProduct> {
		return map(DeliveryProduct.Construct)(arrParams);
	}

	public static Construct(
		params: IDeliveryProductConstructorParams,
	): DeliveryProduct {
		return new DeliveryProduct(params);
	}

	responseData: IDeliveryProductConstructorParams;

	constructor(params: IDeliveryProductConstructorParams) {
		super(params);
		this.responseData = params;
	}

	get id(): ID {
		if (this.responseData.id) {
			return this.responseData.id;
		}

		return null;
	}

	get name(): string {
		return this.responseData.name;
	}

	get description(): string {
		return this.responseData.description;
	}
}

export default DeliveryProduct;
